import Api from '@/services/Api';

export default {
  getMe() {
    return Api().get('me');
  },
};
